(function () {
  'use strict';

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents) {
    if (window.theme && theme.Currency) return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    return (cents / 100).toFixed(2);
  }

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || r.status); });
      return r.json();
    });
  }

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function imageUrl(src, width) {
    if (!src) return '';
    var url = src.indexOf('//') === 0 ? 'https:' + src : src;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  /* /collections/<handle>/products.json uses decimal strings and no url: map it to the Ajax product shape */
  function toCents(v) {
    return typeof v === 'number' ? v : Math.round(parseFloat(v || '0') * 100);
  }

  function normalizeCollectionProduct(p) {
    return {
      id: p.id,
      title: p.title,
      url: root + 'products/' + p.handle,
      featured_image: p.images && p.images[0] ? p.images[0].src : null,
      variants: (p.variants || []).map(function (v) {
        return { id: v.id, available: v.available, price: toCents(v.price), compare_at_price: v.compare_at_price ? toCents(v.compare_at_price) : null };
      })
    };
  }

  /* Recommended products in the drawer */
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var PLUS_ICON = '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M6 1v10M1 6h10" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

  function bindUpsellCarousel(box) {
    if (box.jpCarousel) return box.jpCarousel;
    var list = box.querySelector('[data-jp-upsell-list]');
    var controls = box.querySelector('[data-jp-upsell-controls]');
    var prev = box.querySelector('[data-jp-upsell-prev]');
    var next = box.querySelector('[data-jp-upsell-next]');
    function update() {
      var max = list.scrollWidth - list.clientWidth;
      if (controls) controls.hidden = max <= 2;
      if (prev) prev.setAttribute('aria-disabled', String(list.scrollLeft <= 2));
      if (next) next.setAttribute('aria-disabled', String(list.scrollLeft >= max - 2));
    }
    function move(direction, instant) {
      var card = list.firstElementChild;
      if (!card) return;
      var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
      list.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: instant || reducedMotion.matches ? 'instant' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function (e) {
      if (prev.getAttribute('aria-disabled') !== 'true') move(-1, e.detail === 0);
    });
    if (next) next.addEventListener('click', function (e) {
      if (next.getAttribute('aria-disabled') !== 'true') move(1, e.detail === 0);
    });
    list.addEventListener('scroll', update, { passive: true });
    list.addEventListener('keydown', function (e) {
      if (e.target !== list || e.altKey || e.ctrlKey || e.metaKey) return;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault();
        move(e.key === 'ArrowLeft' ? -1 : 1, true);
      } else if (e.key === 'Home' || e.key === 'End') {
        e.preventDefault();
        list.scrollTo({ left: e.key === 'Home' ? 0 : list.scrollWidth, behavior: 'instant' });
      }
    });
    // Reveal tabbed links/buttons inside this scroller without moving the drawer vertically.
    list.addEventListener('focusin', function (e) {
      var card = e.target.closest('.jp-upsell__item');
      if (!card) return;
      var bounds = list.getBoundingClientRect();
      var rect = card.getBoundingClientRect();
      if (rect.left < bounds.left || rect.right > bounds.right) {
        list.scrollBy({ left: rect.left - bounds.left, behavior: 'instant' });
      }
    });
    if (window.ResizeObserver) {
      var observer = new ResizeObserver(update);
      observer.observe(list);
      box.jpCarouselObserver = observer;
    }
    box.jpCarousel = update;
    return update;
  }

  function renderUpsell(cart) {
    document.querySelectorAll('[data-jp-upsell]').forEach(function (box) {
      var list = box.querySelector('[data-jp-upsell-list]');
      if (!cart.items.length) { box.hidden = true; box.jpUpsellKey = null; return; }
      var first = cart.items[0].product_id;
      var inCart = cart.items.map(function (i) { return i.product_id; });
      var wrap = document.querySelector('[data-jp-giftwrap]');
      var limit = parseInt(box.dataset.limit, 10) || 4;
      var key = first + ':' + inCart.join(',');
      if (box.jpUpsellKey === key) return;
      box.jpUpsellKey = key;

      var want = limit + inCart.length + 1;
      fetch(box.dataset.url + '.json?product_id=' + first + '&limit=' + want + '&intent=related')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (data) {
          if (data.products && data.products.length) return data.products;
          return fetch(box.dataset.fallbackUrl + '?limit=' + (want + 8))
            .then(function (r) { return r.ok ? r.json() : { products: [] }; })
            .then(function (d) { return (d.products || []).map(normalizeCollectionProduct); });
        })
        .then(function (candidates) {
          if (!box.isConnected || box.jpUpsellKey !== key) return;
          var products = (candidates || []).filter(function (p) {
            var variant = (p.variants || []).find(function (v) { return v.available; });
            if (wrap && p.variants.some(function (v) { return String(v.id) === wrap.dataset.variantId; })) return false;
            return variant && inCart.indexOf(p.id) === -1;
          }).slice(0, limit);

          var hadFocus = list.contains(document.activeElement) || (box.jpUpsellFocus && document.activeElement === document.body);
          box.jpUpsellFocus = false;
          list.textContent = '';
          products.forEach(function (p) {
            var variant = p.variants.find(function (v) { return v.available; });
            var li = document.createElement('li');
            li.className = 'jp-upsell__item';

            var link = document.createElement('a');
            link.className = 'jp-upsell__media';
            link.href = p.url;
            link.tabIndex = -1;
            link.setAttribute('aria-hidden', 'true');
            if (p.featured_image) {
              var img = document.createElement('img');
              img.src = imageUrl(p.featured_image, 120);
              img.alt = '';
              img.width = 44;
              img.height = 55;
              img.loading = 'lazy';
              img.decoding = 'async';
              link.appendChild(img);
            }

            var info = document.createElement('div');
            info.className = 'jp-upsell__info';
            var title = document.createElement('a');
            title.className = 'jp-upsell__name';
            title.href = p.url;
            title.textContent = p.title;
            var price = document.createElement('span');
            price.className = 'jp-upsell__price';
            price.textContent = money(variant.price);
            if (variant.compare_at_price > variant.price) {
              var s = document.createElement('s');
              s.textContent = money(variant.compare_at_price);
              price.appendChild(document.createTextNode(' '));
              price.appendChild(s);
            }
            info.appendChild(title);
            info.appendChild(price);

            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'btn jp-upsell__add';
            btn.innerHTML = PLUS_ICON;
            btn.title = box.dataset.button;
            btn.setAttribute('aria-label', box.dataset.button + ': ' + p.title);
            btn.addEventListener('click', function () {
              if (btn.disabled) return;
              var restoreFocus = document.activeElement === btn;
              box.jpUpsellFocus = restoreFocus;
              btn.disabled = true;
              btn.setAttribute('aria-busy', 'true');
              btn.classList.add('btn--loading');
              var err = box.querySelector('[data-jp-upsell-error]');
              if (err) err.hidden = true;
              post('cart/add.js', { items: [{ id: variant.id, quantity: 1 }] })
                .then(function () {
                  btn.classList.add('is-added');
                  btn.textContent = '✓';
                  var status = box.querySelector('[data-jp-upsell-status]');
                  if (status) status.textContent = p.title + ' — Přidáno do košíku';
                  document.dispatchEvent(new CustomEvent('jp:added'));
                  refreshCart();
                })
                .catch(function (e) {
                  box.jpUpsellFocus = false;
                  if (err) { err.textContent = e.message; err.hidden = false; }
                })
                .finally(function () {
                  btn.disabled = btn.classList.contains('is-added');
                  btn.removeAttribute('aria-busy');
                  btn.classList.remove('btn--loading');
                  if (!btn.disabled && restoreFocus && document.activeElement === document.body) btn.focus({ preventScroll: true });
                });
            });

            li.appendChild(link);
            li.appendChild(info);
            li.appendChild(btn);
            list.appendChild(li);
          });
          box.hidden = products.length === 0;
          list.scrollLeft = 0;
          bindUpsellCarousel(box)();
          if (hadFocus) {
            var focus = products.length ? list : document.querySelector('#CartDrawer .js-drawer-close');
            if (focus) focus.focus({ preventScroll: true });
          }
        })
        .catch(function () {
          if (box.jpUpsellKey !== key) return;
          box.hidden = true;
          box.jpUpsellKey = null;
        });
    });
  }

  /* Gift wrap */
  function syncGiftwrap(cart) {
    document.querySelectorAll('[data-jp-giftwrap]').forEach(function (el) {
      var id = el.dataset.variantId;
      el.querySelector('input').checked = cart.items.some(function (i) { return String(i.variant_id) === id; });
    });
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    var el = input.closest && input.closest('[data-jp-giftwrap]');
    if (!el) return;
    var id = el.dataset.variantId;
    var prevMsg = el.querySelector('[data-jp-giftwrap-error]');
    if (prevMsg) prevMsg.hidden = true;
    input.disabled = true;
    el.setAttribute('aria-busy', 'true');
    var request = input.checked
      ? post('cart/add.js', { items: [{ id: parseInt(id, 10), quantity: 1 }] })
      : post('cart/change.js', { id: id, quantity: 0 });
    request
      .then(function () {
        if (document.querySelector('#CartPageForm')) window.location.reload();
        else refreshCart();
      })
      .catch(function (err) {
        input.checked = !input.checked;
        var msg = el.querySelector('[data-jp-giftwrap-error]');
        if (msg) { msg.textContent = err.message; msg.hidden = false; }
      })
      .finally(function () { input.disabled = false; el.removeAttribute('aria-busy'); });
  });

  function onCart(cart) {
    renderUpsell(cart);
    syncGiftwrap(cart);
  }

  /* Cart change bus: Impulse only emits cart:updated on quantity changes, not after
     ajax add or cart:build, so every jp cart feature listens to jp:cart instead. */
  var pending;
  function announce(cart) {
    document.dispatchEvent(new CustomEvent('jp:cart', { detail: { cart: cart } }));
  }
  function refetch() {
    clearTimeout(pending);
    pending = setTimeout(function () { getCart().then(announce).catch(function () {}); }, 200);
  }
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart) announce(e.detail.cart);
    else refetch();
  });
  document.addEventListener('ajaxProduct:added', refetch);
  document.addEventListener('cart:build', refetch);
  /* Cart icon bump: driven by "added" events, not by comparing counts (the cart can change in another tab) */
  function bumpCartIcon() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.cart-link').forEach(function (link) {
      link.classList.remove('jp-bump');
      void link.offsetWidth;
      link.classList.add('jp-bump');
      link.addEventListener('animationend', function () { link.classList.remove('jp-bump'); }, { once: true });
    });
  }
  document.addEventListener('ajaxProduct:added', bumpCartIcon);
  document.addEventListener('jp:added', bumpCartIcon);
  document.addEventListener('jp:cart', function (e) { onCart(e.detail.cart); });

  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-jp-upsell]').forEach(function (box) {
      if (box.jpCarouselObserver) box.jpCarouselObserver.disconnect();
    });
  });
  document.addEventListener('shopify:section:load', function () {
    getCart().then(onCart).catch(function () {});
  });

  /* Presentation only: retain the existing cart and tier calculations. */
  function bindDrawerMotion() {
    var drawer = document.querySelector('[data-jp-cd]');
    if (!drawer || drawer.jpMotion) return;
    var list = drawer.querySelector('[data-products]');
    var previous = new Map();
    function remember() {
      previous.clear();
      if (!list) return;
      list.querySelectorAll('.cart__item').forEach(function (item) {
        previous.set(item.dataset.key, item.getBoundingClientRect().top);
      });
    }
    drawer.addEventListener('click', remember, true);
    drawer.addEventListener('change', remember, true);
    function syncProgress() {
      // The tier renderer owns width/aria-valuenow. Mirror its result as scaleX.
      drawer.querySelectorAll('.jp-progress__fill').forEach(function (fill) {
        var scale = Math.max(0, Math.min(100, parseFloat(fill.style.width) || 0)) / 100;
        var transform = 'scaleX(' + scale + ')';
        if (fill.style.transform !== transform) fill.style.transform = transform;
      });
    }
    syncProgress();
    var observer = new MutationObserver(function (records) {
      syncProgress();
      if (!list || !records.some(function (record) { return record.type === 'childList' && record.target === list; })) return;
      if (!reducedMotion.matches && drawer.classList.contains('drawer--is-open') && !drawer.classList.contains('is-entering')) {
        list.querySelectorAll('.cart__item').forEach(function (item, index) {
          if (!item.animate) return;
          var before = previous.get(item.dataset.key);
          var delta = before === undefined ? 8 : before - item.getBoundingClientRect().top;
          if (before !== undefined && Math.abs(delta) < 1) return;
          item.animate([
            { transform: 'translateY(' + delta + 'px)', opacity: before === undefined ? 0 : 1 },
            { transform: 'translateY(0)', opacity: 1 }
          ], { duration: 240, delay: before === undefined ? Math.min(index, 3) * 35 : 0, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' });
        });
      }
      remember();
    });
    observer.observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    drawer.jpMotion = observer;
    remember();
  }
  reducedMotion.addEventListener('change', function () {
    var drawer = document.querySelector('[data-jp-cd]');
    if (reducedMotion.matches && drawer && drawer.getAnimations) {
      drawer.getAnimations({ subtree: true }).forEach(function (animation) { animation.cancel(); });
      var list = drawer.querySelector('[data-jp-upsell-list]');
      if (list) list.scrollTo({ left: list.scrollLeft, behavior: 'instant' });
    }
  });
  document.addEventListener('shopify:section:load', bindDrawerMotion);
  document.addEventListener('shopify:section:unload', function (e) {
    var drawer = e.target.querySelector('[data-jp-cd]');
    if (drawer && drawer.jpMotion) drawer.jpMotion.disconnect();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindDrawerMotion);
  else bindDrawerMotion();

  if (document.querySelector('[data-jp-upsell], [data-jp-giftwrap]')) {
    getCart().then(onCart).catch(function () {});
  }
})();

/* Bundle builder: pick N items, add all at once */
(function () {
  'use strict';
  if (!window.customElements || customElements.get('jp-bundle')) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CLOSE = '<svg viewBox="0 0 10 10" aria-hidden="true" focusable="false"><path d="M1 1l8 8M9 1 1 9" stroke="currentColor" stroke-width="1.6"/></svg>';

  function money(cents) {
    if (window.theme && theme.Currency) return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    return (cents / 100).toFixed(2);
  }

  customElements.define('jp-bundle', class extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.size = parseInt(this.dataset.size, 10) || 3;
      this.picks = [];
      this.slots = Array.prototype.slice.call(this.querySelectorAll('[data-jp-slot]'));
      this.status = this.querySelector('[data-jp-status]');
      this.totalEl = this.querySelector('[data-jp-total]');
      this.addBtn = this.querySelector('[data-jp-add]');
      this.error = this.querySelector('[data-jp-error]');
      this.bar = this.querySelector('[data-jp-bar]');
      this.fill = this.querySelector('[data-jp-fill]');

      this.addEventListener('click', (e) => {
        var pick = e.target.closest('[data-jp-pick]');
        if (pick) return this.pick(pick);
        var remove = e.target.closest('[data-jp-remove]');
        if (remove) return this.unpick(parseInt(remove.dataset.index, 10));
      });
      this.addBtn.addEventListener('click', () => this.submit());
      this.render();
    }

    pick(btn) {
      if (this.picks.length >= this.size) {
        this.flash();
        return;
      }
      var card = btn.closest('.jp-bundle__card');
      var input = card.querySelector('[data-jp-variant]');
      var option = input.tagName === 'SELECT' ? input.options[input.selectedIndex] : input;
      this.fly(card.querySelector('.jp-bundle__media img'), this.slots[this.picks.length]);
      this.picks.push({
        id: parseInt(input.value, 10),
        price: parseInt(option.dataset.price, 10) || 0,
        title: btn.dataset.title + (input.tagName === 'SELECT' ? ' – ' + option.dataset.title : ''),
        image: btn.dataset.image,
        card: card
      });
      this.render();
    }

    fly(img, slot) {
      if (!img || !slot || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !img.animate) return;
      var from = img.getBoundingClientRect();
      var to = slot.getBoundingClientRect();
      if (!from.width || !to.width) return;
      var ghost = img.cloneNode();
      ghost.className = 'jp-fly';
      ghost.removeAttribute('srcset');
      ghost.removeAttribute('sizes');
      ghost.style.cssText = 'position:fixed;z-index:60;pointer-events:none;object-fit:cover;left:' + from.left + 'px;top:' + from.top + 'px;width:' + from.width + 'px;height:' + from.height + 'px;';
      document.body.appendChild(ghost);
      var dx = to.left + to.width / 2 - (from.left + from.width / 2);
      var dy = to.top + to.height / 2 - (from.top + from.height / 2);
      var scale = to.width / from.width;
      ghost.animate([
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + scale + ')', opacity: .6 }
      ], { duration: 520, easing: 'cubic-bezier(.22,1,.36,1)' }).finished.then(function () { ghost.remove(); }, function () { ghost.remove(); });
    }

    unpick(index) {
      this.picks.splice(index, 1);
      this.render();
      var next = this.querySelector('[data-jp-remove]') || this.addBtn;
      if (next) next.focus();
    }

    flash() {
      this.status.classList.remove('is-flash');
      void this.status.offsetWidth;
      this.status.classList.add('is-flash');
    }

    render() {
      var count = this.picks.length;
      this.slots.forEach((slot, i) => {
        var p = this.picks[i];
        slot.classList.toggle('is-filled', !!p);
        slot.textContent = '';
        if (!p) {
          var num = document.createElement('span');
          num.className = 'jp-bundle__slot-num';
          num.setAttribute('aria-hidden', 'true');
          num.textContent = i + 1;
          slot.appendChild(num);
          return;
        }
        if (p.image) {
          var img = document.createElement('img');
          img.src = p.image;
          img.alt = '';
          slot.appendChild(img);
        }
        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'jp-bundle__remove';
        rm.dataset.jpRemove = '';
        rm.dataset.index = i;
        rm.setAttribute('aria-label', '× ' + p.title);
        rm.innerHTML = CLOSE;
        slot.appendChild(rm);
      });

      this.querySelectorAll('.jp-bundle__card').forEach((card) => {
        card.classList.toggle('is-picked', this.picks.some(function (p) { return p.card === card; }));
      });

      var total = this.picks.reduce(function (sum, p) { return sum + p.price; }, 0);
      var prevTotal = this._total || 0;
      this._total = total;
      if (window.jpCore && jpCore.tweenText) jpCore.tweenText(this.totalEl, prevTotal, total, money);
      else this.totalEl.textContent = money(total);
      this.status.textContent = (this.status.dataset.template || '').replace('[count]', count).replace('[size]', this.size);
      this.bar.setAttribute('aria-valuenow', count);
      this.fill.style.width = Math.round(count / this.size * 100) + '%';
      this.addBtn.disabled = count !== this.size;
    }

    submit() {
      if (this.picks.length !== this.size) return;
      var qty = {};
      this.picks.forEach(function (p) { qty[p.id] = (qty[p.id] || 0) + 1; });
      var items = Object.keys(qty).map((id) => ({ id: parseInt(id, 10), quantity: qty[id], properties: { _bundle: this.dataset.sectionId } }));
      this.addBtn.disabled = true;
      this.addBtn.setAttribute('aria-busy', 'true');
      this.addBtn.classList.add('btn--loading');
      this.error.hidden = true;
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || r.status); });
          return r.json();
        })
        .then(() => {
          this.picks = [];
          this.render();
          document.dispatchEvent(new CustomEvent('jp:added'));
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:open'));
        })
        .catch((err) => {
          this.error.textContent = err.message;
          this.error.hidden = false;
          this.addBtn.disabled = false;
        })
        .finally(() => {
          this.addBtn.removeAttribute('aria-busy');
          this.addBtn.classList.remove('btn--loading');
        });
    }
  });
})();

/* Quantity breaks: sync radio choice with the product form quantity */
(function () {
  'use strict';

  function formFor(el) {
    var section = el.closest('[id^="ProductSection-"]');
    return (section || document).querySelector('form.product-single__form');
  }

  function quantityInput(form) {
    // Impulse's quantity selector sits outside the <form> and joins it via form="id", so look in form.elements.
    var input = Array.prototype.find.call(form.elements, function (el) { return el.name === 'quantity'; });
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'quantity';
      input.value = '1';
      form.appendChild(input);
    }
    return input;
  }

  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('[data-jp-qb]');
    if (!box || e.target.type !== 'radio') return;
    var form = formFor(box);
    if (!form) return;
    var input = quantityInput(form);
    input.value = e.target.value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Keep the radio cards in step when the shopper edits the theme's quantity field */
  function syncBreaksFrom(input) {
    var section = input.closest('[id^="ProductSection-"]') || document;
    var box = section.querySelector('[data-jp-qb]');
    if (!box) return;
    var value = String(parseInt(input.value, 10) || 1);
    box.querySelectorAll('input[type="radio"]').forEach(function (r) { r.checked = r.value === value; });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.name === 'quantity' && t.form && t.form.matches('form.product-single__form')) syncBreaksFrom(t);
  });
  document.addEventListener('click', function (e) {
    var adjust = e.target.closest && e.target.closest('.js-qty__adjust');
    if (!adjust) return;
    var input = adjust.parentElement && adjust.parentElement.querySelector('input[name="quantity"]');
    if (input && input.form && input.form.matches('form.product-single__form')) setTimeout(function () { syncBreaksFrom(input); }, 0);
  });

  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v || !window.theme || !theme.Currency) return;
    document.querySelectorAll('[data-jp-qb]').forEach(function (box) {
      box.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        var qty = parseInt(radio.value, 10);
        var pct = parseInt(radio.dataset.pct, 10) || 0;
        var body = radio.nextElementSibling;
        var full = v.price * qty;
        body.querySelector('[data-jp-qb-total]').textContent = theme.Currency.formatMoney(Math.round(full * (100 - pct) / 100), theme.settings.moneyFormat);
        var fullEl = body.querySelector('[data-jp-qb-full]');
        if (fullEl) fullEl.textContent = theme.Currency.formatMoney(full, theme.settings.moneyFormat);
      });
    });
  });
})();

/* Sticky add-to-cart bar: shows once the main add-to-cart button scrolls above the viewport */
(function () {
  'use strict';
  if (!window.customElements || customElements.get('jp-sticky-atc')) return;

  customElements.define('jp-sticky-atc', class extends HTMLElement {
    connectedCallback() {
      var section = this.closest('[id^="ProductSection-"]') || document;
      this.mainBtn = section.querySelector('form.product-single__form [data-add-to-cart]');
      this.btn = this.querySelector('[data-jp-sticky-btn]');
      if (!this.mainBtn || !this.btn || !('IntersectionObserver' in window)) return;

      // Root extended far below the viewport: the button only stops intersecting once it is above the top edge,
      // so jumps (anchor links, restored scroll, fast flings) still flip the state.
      this.observer = new IntersectionObserver((entries) => {
        var e = entries[entries.length - 1];
        this.show(!e.isIntersecting);
      }, { rootMargin: '0px 0px 100000px 0px' });
      this.observer.observe(this.mainBtn);

      if (!this._bound) {
        this._bound = true;
        this.btn.addEventListener('click', () => {
          if (this.mainBtn.disabled) { this.mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
          this.mainBtn.click();
        });
        this.onVariant = (e) => {
          var v = e.detail && e.detail.variant;
          if (!v || !window.theme || !theme.Currency) return;
          var price = this.querySelector('[data-jp-sticky-price]');
          if (price) price.textContent = theme.Currency.formatMoney(v.price, theme.settings.moneyFormat);
          var cmp = this.querySelector('[data-jp-sticky-compare]');
          if (cmp) cmp.hidden = !(v.compare_at_price > v.price);
          this.btn.disabled = !v.available;
        };
        document.addEventListener('variant:change', this.onVariant);
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.onVariant) document.removeEventListener('variant:change', this.onVariant);
      this._bound = false;
    }

    show(on) {
      this.classList.toggle('is-visible', on);
      this.setAttribute('aria-hidden', on ? 'false' : 'true');
      this.btn.tabIndex = on ? 0 : -1;
    }
  });
})();
